import IsSyndicContainer from "./IsSyndicContainer";
import SirenSocietyForm from "./SirenClientForm";

const NewSyndicForm = () => {
	return (
		<div className="flex flex-col gap-4">
			<h1 className="text-[#144C65] text-2xl font-medium">Nouveau syndic</h1>
			<div className="flex flex-col border-solid border-1 border-gray-200 rounded-lg p-4 gap-4">
				<div className="flex flex-col items-center gap-4">
					<SirenSocietyForm formKey="syndicSociety" isClient={false} />
					<IsSyndicContainer formKey="syndicSociety" />
				</div>
			</div>
		</div>
	);
};

export default NewSyndicForm;
